var map = {
	"./facebookIcon.svg": 33043,
	"./instagramIcon.svg": 82339,
	"./twitterIcon.svg": 50626,
	"./youtubeIcon.svg": 51205,
	"Common/Assets/Icons/Socials/facebookIcon.svg": 33043,
	"Common/Assets/Icons/Socials/instagramIcon.svg": 82339,
	"Common/Assets/Icons/Socials/twitterIcon.svg": 50626,
	"Common/Assets/Icons/Socials/youtubeIcon.svg": 51205
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 66683;